import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { User } from '../../../models/user';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { TranslateService } from '@ngx-translate/core';
import { GeneralService } from '../../../services/admin/general.service';
import { EMService } from '../../../services/invoices-em/em.service';
import { StorageService } from '../../../services/storage.service';
import { CatalogsService } from '../../../services/catalogs/catalogs.service';
import { InvoicesVendorService } from '../../../services/invoices-vendor/invoices-vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
  selector: 'app-invoices-vendor-massive',
  templateUrl: './invoices-vendor-massive.component.html',
  styleUrls: ['./invoices-vendor-massive.component.scss'],
  providers: [GeneralService, EMService, CatalogsService, InvoicesVendorService]

})
export class InvoicesVendorMassiveComponent implements OnInit {

  @ViewChild('myTable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  rol;
  pais;
 
  selectedFile;
  file;
  files1;
  files2;
  mensajeVerificarDatos;
  sinDatos;
  archivoNoValido;
  rows = [];
  columns;
  flagExcel = false;
  btnEnviar = false;
  jsonExcel = null;
  closeResult: string;
  archivoZip;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  busy: boolean = false;
  busyEnvio: boolean = false;

  cuentaProvSelected: Object;
  cuentas: Array<object>

  toastCamposVacios;
  provSinCuenta;

  public tipo: boolean = false;
  public file1: string = "";
  public file2: string = "";

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private emService: EMService,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private catalogos: CatalogsService,
    private invoicesVendor: InvoicesVendorService,
    private modalService: NgbModal
  ) {
    // this.getProveedores();
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

     this.translate.get('texto.mensajeVerificarDatos').subscribe(
      text => {
      this.mensajeVerificarDatos = text;
    });

    this.translate.get('texto.sinDatos').subscribe(
      text => {
      this.sinDatos = text;
    });

    this.translate.get('texto.archivoNoValido').subscribe(
      text => {
      this.archivoNoValido = text;
    });

    this.cuentaProvSelected = {};
    this.cuentas = [];
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    this.pais = this.user.pais;
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  
  clearInput(e) {
    this.selectedFile = e.target.value = '';
    this.file = e.target.value = '';
  }

  readExcelToJSON(e, files1, files2) {
      // if (e.target.value !== "") {

        let me = this;
        this.archivoZip = files2[0];
        this.selectedFile = files1[0];
        // this.file = e.target.files[0]; 
        // console.log(this.selectedFile)
        let tipo = this.selectedFile.name.split('.');
  
        if (tipo[1] == "xlsx" || tipo[1] == "csv" || tipo[1] == "xls") {
          var fileReader = new FileReader();
          fileReader.onload = function(event) {
              var data = (<FileReader>event.target).result;
              var workbook = XLSX.read(data, {
                  type: "binary"
              });
              workbook.SheetNames.forEach(sheet => {
                  let rowObject = XLSX.utils.sheet_to_json(
                      workbook.Sheets[sheet]
                  );
                  
                  if (rowObject.length > 0) {

                    // console.log(rowObject);

                    let keys = Object.keys(rowObject[0]); 


                    let proveedor = false;
                    let oc = false
                    let importe = false;
                    let factura = false;
                    for (let k = 0; k < keys.length; k++ ) {
                      
                      if (keys[k].toLowerCase()  === 'vendor') {
                        proveedor = true;
                      }
                      if (keys[k].toLowerCase()  === 'po') {
                        oc = true; 
                      }
                      if (keys[k].toLowerCase() === 'totalAmount') {
                        importe = true; 
                      }
                      if (keys[k].toLowerCase() === 'invoice') {
                        factura = true; 
                      }
                      
                    }

                    var json = {
                      proveedor: '',
                      ordenCompra: '',
                      importe: '',
                      folio: '',
                      nombreFactura: '',
                      anioFiscal: ''
                    }
      
                  
                    if (proveedor || oc || importe || factura) {

                      var jsonArray = [];
                      let year = new Date().getFullYear();
                      let PROVEEDOR="",OC="",IMPORTE="",FACTURA="";
                     
                      for (let i = 0; i < rowObject.length; i++) {
                        if (rowObject[i]['vendor']) {
                          PROVEEDOR = rowObject[i]['vendor'];
                        } else {
                          PROVEEDOR = "";
                        }
                        if (rowObject[i]['po']) {
                          OC = rowObject[i]['po'];
                        } else {
                          OC = "";
                        }
                        if (rowObject[i]['totalAmount']) {
                          IMPORTE = rowObject[i]['totalAmount'];
                        } else {
                          IMPORTE = "";
                        }
                        if (rowObject[i]['invoice']) {
                          FACTURA = rowObject[i]['invoice'];
                        } else {
                          FACTURA = "";
                        }
                        

                        json = {
                          proveedor: String(PROVEEDOR),
                          ordenCompra:String(OC),
                          importe: String(IMPORTE),
                          folio: '',
                          nombreFactura: String(FACTURA),
                          anioFiscal: String(year)
                        }
                        if (json.proveedor == '' || json.ordenCompra == '' || json.importe == '' || json.nombreFactura == '' ) {
                          me.columns = [];
                          me.rows = [];
                          me.btnEnviar = false;
                          me.files1.length = 0;
                          me.toasterService.pop('error', '', me.mensajeVerificarDatos);
                          return;
                        }else{

                          jsonArray.push(json)
                        }
                      }
          
                        me.columns = keys;
                        me.rows = rowObject;
                        me.btnEnviar = true 

                        me.jsonExcel = jsonArray;

                    }  else {
                        me.columns = [];
                        me.rows = [];
                        me.btnEnviar = false;
                        me.files1.length = 0;
                        me.toasterService.pop('error', '', me.mensajeVerificarDatos);
                    }
                   
                  } else {
                      me.columns = [];
                      me.rows = [];
                      me.btnEnviar = false;
                      me.files1.length = 0;
                      me.toasterService.pop('error', '', me.sinDatos);
                  }
                 
              });
          }
          fileReader.readAsBinaryString(me.selectedFile); 
          fileReader.onloadend = function () {
            if (me.btnEnviar) {
              me.enviar();
            }
          };
        } else {
          me.columns = [];
          me.rows = [];
          me.btnEnviar = false;
          me.files1.length = 0;
          me.toasterService.pop('error', '', this.archivoNoValido);
        }
              
      //}
     
  }

 
  enviar() {
    this.busy = true;
    let obj = {
      facturaBatchExcel: this.jsonExcel
    }; 
    
    this.invoicesVendor.cargarFacturaMasiva(this.user.id, obj).subscribe(
      data => {
        this.busy = false;
        
        if (!isNumber(data.resultado)) {
          this.toasterService.pop('error', '', data.resultado);
        } else {
          this.cargarZip(data.resultado, this.archivoZip);
        }

      },
      err => {
        this.busy = false;

        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', '', err.error.message);
        }
        
      },
    );

  }

  cargarZip(batch, zip) {
    this.busy = true;

    const formData: FormData = new FormData();  
      formData.append('file', zip),

    this.emService.postCargaZIP(batch, formData, false).subscribe(
      data => { 
        let response = data;
        
        if (response.resultado && response.resultado === "OK") {
          this.files1.length = 0;
          this.files2.length = 0;
          this.btnEnviar = false;
          this.toasterService.pop('success', '', response.resultado);
        } else {
          this.toasterService.pop('error', '', response.resultado);
        }

        this.busy = false;

      },
      err => { 
        this.busy = false;
       
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', '', err.error.message);
        }
      },
    );

  }
}



// WEBPACK FOOTER //
// ./src/app/pages/invoices-vendor-massive/invoices-vendor-massive/invoices-vendor-massive.component.ts